

























import Component from 'vue-class-component';
import {CodeRetrieveResponse, CommonReasonDialogRequest} from '@/model/CommonModel';
import RadioInput from '@/components/input/RadioInput.vue';
import {Mixins} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import StringUtils from '@/utils/StringUtils';
import DefaultFormMixin from '@/views/DefaultFormMixin';

@Component({
    components: {
        RadioInput, CommonPromptDialog
    },
    mixins: [
        DialogEventsMixin, DefaultFormMixin
    ]
})
export default class CommonReasonDialog extends Mixins(DialogEventsMixin, DefaultFormMixin) {
    private dialogVisible = false;
    private width: string = '400px';
    private title: string = '';
    private content: string = '';
    private onClose: any;
    private onConfirm: any;
    
    private options: CodeRetrieveResponse[] = [{
        codeLabel: 'Input Error',
        codeValue: 'Input Error'
    }, {
        codeLabel: 'New Data',
        codeValue: 'New Data'
    }, {
        codeLabel: 'Edited Data',
        codeValue: 'Edited Data'
    }, {
        codeLabel: 'Others',
        codeValue: 'Others'
    }];
    
    private form: any = {
        data: {
            reason: this.options[0].codeValue,
            othersReason: ''
        },
        rules: {
            reason: [
                {
                    validator: (rule: any, value: any, callback: any) => {
                        if (!this.hasValue(value) || (value === 'Others' && !this.hasValue(this.form.data.othersReason))) {
                            callback(new Error(this.$root.$t('message.commonReasonDialog.required').toString()));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'change'
                }
            ]
        }
    };
    
    private hasValue(value: any) {
        return StringUtils.hasValue(value) || (value instanceof String && StringUtils.hasValue(value.replace(/ /g, '')));
    }
    
    get isVisible() {
        return this.dialogVisible;
    }
    
    get getWidth() {
        return this.width;
    }
    
    get getTitle() {
        return this.title;
    }
    
    get getContent() {
        return this.content;
    }
    
    public mounted() {
        this.$modal
            .getEventBus()
            .$on('reasonDialog', (params: CommonReasonDialogRequest) => {
                this.show(params);
            });
        
        this.$modal.getEventBus().$on('hideReasonDialog', () => this.cancel());
    }
    
    public show(params: CommonReasonDialogRequest) {
        this.dialogVisible = true;
        const {onConfirm, onClose, title, content, width} = params;
        this.onConfirm = onConfirm;
        this.onClose = onClose;
        this.width = width ?? this.width;
        this.title = title ?? this.$t('message.commonReasonDialog.title').toString();
        this.content = content ?? this.$t('message.commonReasonDialog.content').toString();
    }
    
    public onReasonOptionInput(data: string) {
        if (!this.isOthersOptionSelected(data)) {
            this.validateField('reason');
        }
    }
    
    get otherReasonIsDisabled() {
        return !this.isOthersOptionSelected(this.form.data.reason);
    }
    
    private isOthersOptionSelected(data: string) {
        return data === this.options[this.options.length - 1].codeValue;
    }
    
    public confirm() {
        this.validation(() => this.submit());
    }
    
    public submit() {
        if (typeof this.onConfirm === 'function') {
            this.onConfirm({
                reason: !this.isOthersOptionSelected(this.form.data.reason) ? this.form.data.reason : this.form.data.othersReason,
                result: true
            });
            this.hide();
        } else {
            this.hide();
        }
    }
    
    public hide() {
        this.dialogVisible = false;
    }
    
    public cancel() {
        this.hide();
        if (this.onClose) {
            this.onClose();
        }
    }
    
    public afterClosed() {
        this.form.data.reason = this.options[0].codeValue;
        this.form.data.othersReason = '';
    }
    
    public destroyed() {
        this.$modal.getEventBus().$off('reasonDialog');
        this.$modal.getEventBus().$off('hideReasonDialog');
    }
}
